// extracted by mini-css-extract-plugin
export default {"root":"_2D4KB","text-block":"_3mn2x","textBlock":"_3mn2x","prefix":"_2RBkC"};